import styled from 'styled-components'
import { type GetServerSideProps } from 'next'
import { Box } from 'pcln-design-system'
import Layout from '@/components/Layout'
import type { CustomContext, PageProps } from '@/types'
import DEFAULT_META_TAGS from '@/constants/meta'
import Meta from '@/components/Meta'
import useCanonicalUrl from '@/hooks/useCanonicalUrl'
import generateBootstrapData from '../utils/generate-bootstrap-data'
import fetchPCLNHeaderFooterContent from '../server/utils/pcln-header-footer'

const Wrapper = styled(Box)`
  max-width: 750px;
  height: 1225px;
  border: 1px solid #c0c2c7;
  margin: auto;
  margin-top: 2em;
  & iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`

function DsarwWbForm({ headerHTML, footerHTML }: PageProps) {
  const canonicalUrl = useCanonicalUrl()
  return (
    <>
      <Meta
        description={DEFAULT_META_TAGS.description.home}
        pageTitle={DEFAULT_META_TAGS.title.dsarwebform}
        canonicalUrl={canonicalUrl}
      />
      <Layout headerHTML={headerHTML} footerHTML={footerHTML}>
        <Wrapper>
          <iframe
            title="Do Not Sell My Info Request"
            src="https://privacyportal.onetrust.com/webform/ed33089b-b15b-43c7-959d-159b21cbc527/897b811f-ebca-4def-bc29-5a7dbc6fd3d6"
            loading="lazy"
          />
        </Wrapper>
      </Layout>
    </>
  )
}

export const getServerSideProps: GetServerSideProps<PageProps> = async ctx => {
  const { req, res } = ctx as CustomContext
  const bootstrapData = generateBootstrapData('ccpa', req, res)
  const pclnHeaderFooterContent = await fetchPCLNHeaderFooterContent(req, res)

  return {
    props: {
      ...pclnHeaderFooterContent,
      bootstrapData: {
        ...bootstrapData,
        fullSETI: [],
        seti: {},
        signInStatus: { signedIn: false }
      }
    }
  }
}

export default DsarwWbForm
